import type { Directive } from 'vue';

export default <Directive<HTMLElement>>{
  mounted(el) {
    el.focus();
  },
  updated(el) {
    el.focus();
  },
};
